import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

import { colorsToken } from "./tokens/colors.token";
import { fontSizesToken } from "./tokens/fontSizes.token";
import { fontsToken } from "./tokens/fonts.token";
import { sizesToken } from "./tokens/sizes.token";

import { textStyles } from "./textStyles/textStyles";

import { buttonRecipe } from "./recipes/button.recipe";

import { globalCss } from "./global-css";

const customConfig = defineConfig({
    globalCss,
    theme: {
        tokens: {
            colors: colorsToken,
            fontSizes: fontSizesToken,
            fonts: fontsToken,
            sizes: sizesToken,
        },
        textStyles,
        recipes: {
            button: buttonRecipe,
        },
    },
});
export const styles = createSystem(defaultConfig, customConfig);
